import React from 'react';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import cx from 'classnames';
import Logo from '../pcHeader/logo';
import Profile from './profile';
import Menu from './menu';
import cs from './index.module.scss';

const MbHeader = () => {
  const location = useLocation();
  
  // 判断是否在合约或现货页面
  const isTradingPage = /^(\/futures\/contract\/)/.test(location.pathname) || /^(\/spot\/trade\/)/.test(location.pathname);
  
  return (
    <header className={cx(cs.headerWrapMb, isTradingPage ? cs.whiteBg : '')}>
      <Logo />
      <div className={cs.headerRightContent}>
        {/* <Profile /> */}
        <Menu />
      </div>
    </header>
  );
};

export default observer(MbHeader);
